import { IOpColor, IOpParent, IOpOperacja, IOpEtap, IOpKomponent, IOpKKT, IOpNewfoilParams, IOpStatus, OpTouchEnum } from "./IOp"
import { OpEtap } from "./OpEtap"
import { OpKomponent } from "./OpKomponent"
import { OpStatus } from "./OpStatus"

export class OpOperacja implements IOpOperacja {
    
    _id: any = undefined
    version:number=1
    del:number=0
    type:string='op'
    dummy:number=0
    touch: OpTouchEnum = OpTouchEnum.CREATE

    poso:number | undefined = undefined // pos in array operacje[]
    ido:number  | undefined = undefined // operacja_id in array operacje[]
    ide:number  | undefined = undefined // etap_id in operacje[]
   
    status: IOpStatus = new OpStatus()
    parent: IOpParent | undefined = undefined
    etap: IOpEtap | undefined = undefined // create only for etap
    color: IOpColor | undefined = undefined
    kkt: IOpKKT | undefined = undefined
    komponent: IOpKomponent | undefined
    komponent_szerokosc: number | undefined = undefined

    zmiana:number = 0
	krotnosc:number = 1
    procent_kosztow:number = 100
    wydatek_sita_puchn:number|undefined = undefined

    newfoil_params: IOpNewfoilParams | undefined = undefined
   
}
